import {
	REQUEST_EDITABLE_TABLES,
	RECEIVE_EDITABLE_TABLES,
	EDITABLE_TABLES_ERROR,
	RECEIVE_ADD_EDITABLE_TABLE,
	UPDATE_EDITABLE_TABLE_DATA,
	RECEIVE_SAVE_EDITABLE_TABLE,
	REQUEST_SAVE_EDITABLE_TABLE,
	ERROR_SAVE_EDITABLE_TABLE,
} from '../actions/editableTableActionsRedux';

const initialProjectsState = {
	isFetching: false,
	items: [],
	// to know what we have to send to server on save
	localchanges: [],
	error: null,
};

const editableTablesReducer = (state = initialProjectsState, action) => {
	switch (action.type) {
		case REQUEST_EDITABLE_TABLES: {
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		}
		case RECEIVE_EDITABLE_TABLES: {
			// sets new state and fetching ended
			return { ...state, items: action.payload, isFetching: false, error: null, localchanges: [] };
		}
		case EDITABLE_TABLES_ERROR: {
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		}
		case RECEIVE_ADD_EDITABLE_TABLE: {
			// add change to local changes

			return {
				...state,
				localchanges: [...state.localchanges, action.payload],
				items: [...state.items, action.payload],
			};
		}
		case UPDATE_EDITABLE_TABLE_DATA: {
			const currentEditableTable = state.items.find((table) => table._id === action.payload._id);

			for (const updateData of action.payload.tableData) {
				const index = currentEditableTable.tableData.findIndex((data) => data.key === updateData.key);
				if (index === -1 && !updateData.deleted) {
					currentEditableTable.tableData = [...currentEditableTable.tableData, updateData];
				} else if (!updateData.deleted) {
					currentEditableTable.tableData[index] = updateData;
				} else {
					currentEditableTable.tableData.splice(index, 1);
				}
			}

			const itemsAfterUpdate = state.items.map((table) =>
				table._id === currentEditableTable._id ? currentEditableTable : table
			);

			if (state.localchanges.find((tbl) => tbl._id === action.payload._id)) {
				const localchangesAfterUpdate = state.localchanges.map((table) =>
					table._id === currentEditableTable._id ? currentEditableTable : table
				);

				return { ...state, localchanges: localchangesAfterUpdate, items: itemsAfterUpdate };
			} else {
				return {
					...state,
					localchanges: [...state.localchanges, currentEditableTable],
					items: itemsAfterUpdate,
				};
			}
		}
		case REQUEST_SAVE_EDITABLE_TABLE: {
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		}
		case RECEIVE_SAVE_EDITABLE_TABLE: {
			let itemsAfterUpdate = [...state.items];
			for (const change of action.payload) {
				itemsAfterUpdate = itemsAfterUpdate.map((table) => (table._id === change._id ? change : table));
			}

			// sets new state and fetching ended
			return { ...state, items: itemsAfterUpdate, isFetching: false, error: null, localchanges: [] };
		}
		case ERROR_SAVE_EDITABLE_TABLE: {
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		}
		default: {
			return state;
		}
	}
};

export default editableTablesReducer;
